export enum NFLTeam {
    ARIZONA_CARDINALS = "ARI Cardinals",
    ATLANTA_FALCONS = "ATL Falcons",
    BALTIMORE_RAVENS = "BAL Ravens",
    BUFFALO_BILLS = "BUF Bills",
    CAROLINA_PANTHERS = "CAR Panthers",
    CHICAGO_BEARS = "CHI Bears",
    CINCINNATI_BENGALS = "CIN Bengals",
    CLEVELAND_BROWNS = "CLE Browns",
    DALLAS_COWBOYS = "DAL Cowboys",
    DENVER_BRONCOS = "DEN Broncos",
    DETROIT_LIONS = "DET Lions",
    GREEN_BAY_PACKERS = "GB Packers",
    HOUSTON_TEXANS = "HOU Texans",
    INDIANAPOLIS_COLTS = "IND Colts",
    JACKSONVILLE_JAGUARS = "JAX Jaguars",
    KANSAS_CITY_CHIEFS = "KC Chiefs",
    LOS_ANGELES_CHARGERS = "LA Chargers",
    LOS_ANGELES_RAMS = "LA Rams",
    MIAMI_DOLPHINS = "MIA Dolphins",
    MINNESOTA_VIKINGS = "MIN Vikings",
    NEW_ENGLAND_PATRIOTS = "NE Patriots",
    NEW_ORLEANS_SANTS = "NO Saints",
    NEW_YORK_GIANTS = "NY Giants",
    NEW_YORK_JETS = "NY Jets",
    LAS_VEGAS_RAIDERS = "LV Raiders",
    PHILADELPHIA_EAGLES = "PHI Eagles",
    PITTSBURGH_STEELERS = "PIT Steelers",
    SAN_FRANCISCO_49ERS = "SF 49ers",
    SEATTLE_SEAHAWKS = "SEA Seahawks",
    TAMPA_BAY_BUCCANEERS = "TB Buccaneers",
    TENNESSEE_TITANS = "TEN Titans",
    WASHINGTON_FB = "WAS Football Team",
}

export enum NFLTeamColour {
    ARIZONA_CARDINALS = "#97233F",
    ATLANTA_FALCONS = "#A71930",
    BALTIMORE_RAVENS = "#241773",
    BUFFALO_BILLS = "#00338D",
    CAROLINA_PANTHERS = "#0085CA",
    CHICAGO_BEARS = "#C83803",
    CINCINNATI_BENGALS = "#FB4F14",
    CLEVELAND_BROWNS = "#FF3C00",
    DALLAS_COWBOYS = "#041E42",
    DENVER_BRONCOS = "#FB4F14",
    DETROIT_LIONS = "#0076B6",
    GREEN_BAY_PACKERS = "#203731",
    HOUSTON_TEXANS = "#03202F",
    INDIANAPOLIS_COLTS = "#002C5F",
    JACKSONVILLE_JAGUARS = "#D7A22A",
    KANSAS_CITY_CHIEFS = "#E31837",
    LOS_ANGELES_CHARGERS = "#0080C6",
    LOS_ANGELES_RAMS = "#FFA300",
    MIAMI_DOLPHINS = "#008E97",
    MINNESOTA_VIKINGS = "#4F2683",
    NEW_ENGLAND_PATRIOTS = "#002244",
    NEW_ORLEANS_SANTS = "#D3BC8D",
    NEW_YORK_GIANTS = "#0B2265",
    NEW_YORK_JETS = "#125740",
    OAKLAND_RAIDERS = "#000000",
    PHILADELPHIA_EAGLES = "#004C54",
    PITTSBURGH_STEELERS = "#FFB612",
    SAN_FRANCISCO_49ERS = "#AA0000",
    SEATTLE_SEAHAWKS = "#002244",
    TAMPA_BAY_BUCCANEERS = "#D50A0A",
    TENNESSEE_TITANS = "#0C2340",
    WASHINGTON_FB = "#773141",
}
